module.exports = __webpack_public_path__ + "img/icon-ticket-lost-color.bccf50b6.svg";